module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_5010.d717dae0.png";